import apiClient from "./apiClient";

const getPreference = ({ userData, cartItems, reseller_code, promotionCode }) => {
    return apiClient.post(`/compras/`, {
        userData,
        cartItems,
        reseller_code,
        promotionCode,
    });
};

const previewPurchase = async ({ cartItems, promotionCode }) => {
    const response = await apiClient.post("/compras/preview", {
        cartItems,
        promotionCode,
    });

    return response.data;
};

export default {
    getPreference,
    previewPurchase,
};
